// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"509":"d5f37c8d","773":"3f63bafe","842":"69295bc9"}[chunkId] + ".chunk.css";
};